import { EE_LU_WO_STATUS } from "../config/BVConstants";

export function getScheduledCount(artifacts) {
  let inprogSchedulecount = 0;
  for (const item of artifacts) {
    if (
      (item?.objProjectStatus?.intId == 30002 && item?.riskStatusId == 1) ||
      item?.objProjectStatus?.intId == 30006
    ) {
      inprogSchedulecount++;
    }
  }
  return inprogSchedulecount;
}

export function getScheduledRiskCount(artifacts) {
  let count = 0;
  for (const item of artifacts) {
    if (
      (item?.objProjectStatus?.intId == 30002 && item?.riskStatusId == 2) ||
      item?.objProjectStatus?.intId == 30006
    ) {
      count++;
    }
  }
  return count;
}

// else if (obMaster.getObjProjectStatus().getIntId() == 30007) {
//     stopCount++;
// }
// else if (obMaster.getObjProjectStatus().getIntId() == 30003) {
//     onholdcount++;

export function getOnHoldCounts(artifacts) {
  let count = 0;
  for (const item of artifacts) {
    if (item?.objProjectStatus?.intId == 30007 || item?.objProjectStatus?.intId == 30003) {
      count++;
    }
  }
  return count;
}

export function getCancelCounts(artifacts) {
  let count = 0;
  for (const item of artifacts) {
    if (item?.objProjectStatus?.intId == 30005) {
      count++;
    }
  }
  return count;
}

const TABLE = 'LU_WO_STATUS';
const Prepare = 4001;
const In_Progress = 4002;
const Complete = 4003;
const Stop = 4004;
const Hold = 4005;
const Cancel = 4006;
const Late = 4007;
const Drafting = 4008;

const Document_Preparation = 4010;
const Document_Preparation_Sample_Collection = 4020;
const Testing_in_Progress = 4030;
const Submission_Complete = 4040;
const Under_Review = 4050;
const Certificate_Received = 4060;

export function getProgressBarChart(objWork) {
  let data = [];
  let intPreDocPrepCount = 0;
  let intCountDocpre = 0;

  let intPreDocPrepSampCollCount = 0;
  let intCountDocSamplepre = 0;

  let intPreTestInProgCount = 0;
  let intCountTest = 0;

  let intPreSubCompleteCount = 0;
  let intcountSubproject = 0;

  let intPreReviewCount = 0;

  let intPreCertReceivedCount = 0;
  let isLocalRep = false;
  let intCountLocalRep = 0;

  let intPreCompleteCount = 0;

  let intPreOnholdCount = 0;
  let intPreStoppedCount = 0;

  let intPreCancelCount = 0;
  let intTotalCountSubProj = 0;
  if (objWork) {
  objWork.map((objWo) => {
    //first
    if (objWo?.objLuWorkOrderStatus !== null && objWo?.objLuWorkOrderStatus?.intId != null) {
      intTotalCountSubProj++;
      if (
        !objWo.boolIsSampleInfo &&
        (objWo.objLuWorkOrderStatus?.intId == Submission_Complete ||
          objWo.objLuWorkOrderStatus?.intId == Under_Review ||
          objWo.objLuWorkOrderStatus?.intId == Certificate_Received ||
          objWo.objLuWorkOrderStatus?.intId == Complete)
      ) {
        intPreDocPrepCount++;
      }
    }
    if (objWo.objLuWorkOrderStatus?.intId != Cancel) {
      intcountSubproject++;
      if (!objWo.boolIsSampleInfo) {
        intCountDocpre++;
      }
    }

    //second
    //double dbDocPrepSampColl = intPreDocPrepSampCollCount!=0?((double)intPreDocPrepSampCollCount/(double)intCountDocSamplepre)*100:0;
    if (
      objWo.boolIsSampleInfo &&
      objWo.intTestingApplicability != null &&
      objWo.intTestingApplicability == 1 &&
      (objWo.objLuWorkOrderStatus?.intId == Testing_in_Progress ||
        objWo.objLuWorkOrderStatus?.intId == Submission_Complete ||
        objWo.objLuWorkOrderStatus?.intId == Under_Review ||
        objWo.objLuWorkOrderStatus?.intId == Certificate_Received ||
        objWo.objLuWorkOrderStatus?.intId == Complete)
    ) {
      intPreDocPrepSampCollCount++;
    }
    if (
      objWo.boolIsSampleInfo &&
      objWo.intTestingApplicability != null &&
      objWo.intTestingApplicability == 2 &&
      (objWo.objLuWorkOrderStatus?.intId == Submission_Complete ||
        objWo.objLuWorkOrderStatus?.intId == Under_Review ||
        objWo.objLuWorkOrderStatus?.intId == Certificate_Received ||
        objWo.objLuWorkOrderStatus?.intId == Complete)
    ) {
      intPreDocPrepSampCollCount++;
    }
    if (objWo.objLuWorkOrderStatus?.intId != Cancel) {
      if (objWo.boolIsSampleInfo) {
        intCountDocSamplepre++;
      }
    }

    //3
    if (
      objWo.boolIsSampleInfo &&
      objWo.intTestingApplicability != null &&
      objWo.intTestingApplicability == 1 &&
      (objWo.objLuWorkOrderStatus?.intId == Submission_Complete ||
        objWo.objLuWorkOrderStatus?.intId == Under_Review ||
        objWo.objLuWorkOrderStatus?.intId == Certificate_Received ||
        objWo.objLuWorkOrderStatus?.intId == Complete)
    ) {
      intPreTestInProgCount++;
    }
    if (objWo.objLuWorkOrderStatus?.intId != Cancel) {
      if (!objWo.boolIsSampleInfo) {
        if (objWo.intTestingApplicability != null && objWo.intTestingApplicability == 2) {
          intCountTest++;
        }
      }
    }

    //4

    if (
      objWo.objLuWorkOrderStatus?.intId == Under_Review ||
      objWo.objLuWorkOrderStatus?.intId == Certificate_Received ||
      objWo.objLuWorkOrderStatus?.intId == Complete
    ) {
      intPreSubCompleteCount++;
    }

    //5

    if (
      objWo.objLuWorkOrderStatus?.intId == Certificate_Received ||
      objWo.objLuWorkOrderStatus?.intId == Complete
    ) {
      intPreReviewCount++;
    }

    //6
    if (
      objWo.objTblService != null &&
      objWo.objTblService?.objLuServiceCode != null &&
      objWo.objTblService?.objLuServiceCode?.intId != 0 &&
      objWo.objTblService?.objLuServiceCode?.intId == 110
    ) {
      isLocalRep = true;
      intCountLocalRep++;
    }

    //7
    if (objWo.objLuWorkOrderStatus?.intId == Complete) {
      if (!isLocalRep) {
        intPreCertReceivedCount++;
        // isCertReceived = true;
      }
      intPreCompleteCount++;
    }

    //8
    if (objWo.objLuWorkOrderStatus?.intId == Hold) {
      intPreOnholdCount++;
    }
    if (objWo.objLuWorkOrderStatus?.intId == Stop) {
      intPreStoppedCount++;
    }

    //9
    if (objWo.objLuWorkOrderStatus?.intId == Cancel) {
      intPreCancelCount++;
    }
  });
}

  data.push(
    progressBarData(
      1,
      'Document Preparation',
      intPreDocPrepCount + '/' + intCountDocpre,
      intCountDocpre !== 0 ? ((intPreDocPrepCount / intCountDocpre) * 100).toFixed(2) : '0.00',
      '#a09a81'
    )
  );
  data.push(
    progressBarData(
      2,
      'Document Preparation & Sample Collection	',
      intPreDocPrepSampCollCount + '/' + intCountDocSamplepre,
      intCountDocSamplepre !== 0
        ? ((intPreDocPrepSampCollCount / intCountDocSamplepre) * 100).toFixed(2)
        : '0.00',
        '#ffbe00'
    )
  );

  data.push(
    progressBarData(
      3,
      'Testing in Progress',
      intPreTestInProgCount + '/' + (intCountDocSamplepre - intCountTest),
      intCountDocSamplepre - intCountTest !== 0
        ? ((intPreTestInProgCount / (intCountDocSamplepre - intCountTest)) * 100).toFixed(2)
        : '0.00',
        '#0FCC88'
    )
  );

  data.push(
    progressBarData(
      4,
      'Submission Complete',
      intPreSubCompleteCount + '/' + intcountSubproject,
      intcountSubproject !== 0
        ? ((intPreSubCompleteCount / intcountSubproject) * 100).toFixed(2)
        : '0.00',
        '#0fcbcc'
    )
  );

  data.push(
    progressBarData(
      5,
      'Application Under Review By Authority',
      intPreReviewCount + '/' + intcountSubproject,
      intcountSubproject !== 0 ? ((intPreReviewCount / intcountSubproject) * 100).toFixed(2) : '0.00',
      '#3e5ae8'
    )
  );

  data.push(
    progressBarData(
      6,
      'Certificate Received',
      intPreCertReceivedCount + '/' + (intcountSubproject - intCountLocalRep),
      intcountSubproject - intCountLocalRep !== 0
        ? ((intPreCertReceivedCount / (intcountSubproject - intCountLocalRep)) * 100).toFixed(2)
        : '0.00',
        '#a04dc1'
    )
  );

  data.push(
    progressBarData(
      7,
      'Completed',
      intPreCompleteCount + '/' + intcountSubproject,
      intcountSubproject !== 0 ? ((intPreCompleteCount / intcountSubproject) * 100).toFixed(2) : '0.00',
      '#d4056c'
    )
  );

  data.push(
    progressBarData(
      8,
      'On Hold',
      intPreOnholdCount + intPreStoppedCount + '/' + intcountSubproject,
      intcountSubproject !== 0
        ? (((intPreOnholdCount + intPreStoppedCount) / intcountSubproject) * 100).toFixed(2)
        : '0.00',
        '#D50237'
    )
  );

  data.push(
    progressBarData(
      9,
      'Cancelled',
      intPreCancelCount + '/' + intTotalCountSubProj,
      intTotalCountSubProj !== 0 ? ((intPreCancelCount / intTotalCountSubProj) * 100).toFixed(2) : '0.00',
      '#FF6920'
    )
  );

  return data;
}

export function getSubProjectStatus(lstWorkOrder) {

    let intOnholdCount=0;
    let intCancelCount=0;
    let intCompleteCount=0;
    let intDocPrepCount=0;
    let intDocPrepSampCollCount=0;
    let intTestInProgCount=0;
    let intSubCompleteCount=0;
    let intReviewCount=0;
    let intCertReceivedCount=0;
    let intStoppedCount=0;
    let intTotalCountSubProj = 0;
    let isCancel = false;
    let isComplete = false;
    let isOnholdStopped = false;
    let isDocPrep = false;
    let isDocPrepSampColl = false;
    let isTestInProg = false;
    let isSubComplete = false;
    let isReview = false;
    let isCertReceived = false;

    if(lstWorkOrder){
      lstWorkOrder?.forEach((objWo) => {
        let isLocalRep = false;
        if(objWo?.objTblService?.objLuServiceCode?.intId!=0 && objWo?.objTblService?.objLuServiceCode?.intId == 110) {
          isLocalRep = true;
        }
        if(objWo?.objLuWorkOrderStatus?.intId) {
            intTotalCountSubProj++;
            if(objWo?.objLuWorkOrderStatus?.intId==EE_LU_WO_STATUS.Cancel) {
                intCancelCount++;
                isCancel = true;
            }else if(objWo?.objLuWorkOrderStatus?.intId==EE_LU_WO_STATUS.Complete) {
                intCompleteCount++;
                isComplete = true;
            }else if(objWo?.objLuWorkOrderStatus?.intId==EE_LU_WO_STATUS.Hold) {
                intOnholdCount++;
                isOnholdStopped = true;
            }else if(objWo?.objLuWorkOrderStatus?.intId==EE_LU_WO_STATUS.Document_Preparation) {
                intDocPrepCount++;
                isDocPrep = true;
            }else if(objWo?.objLuWorkOrderStatus?.intId==EE_LU_WO_STATUS.Document_Preparation_Sample_Collection) {
                intDocPrepSampCollCount++;
                isDocPrepSampColl = true;
            }else if(objWo?.objLuWorkOrderStatus?.intId==EE_LU_WO_STATUS.Testing_in_Progress) {
                intTestInProgCount++;
                isTestInProg = true;
            }else if(objWo?.objLuWorkOrderStatus?.intId==EE_LU_WO_STATUS.Submission_Complete) {
                intSubCompleteCount++;
                isSubComplete = true;
            }else if(objWo?.objLuWorkOrderStatus?.intId==EE_LU_WO_STATUS.Under_Review) {
                intReviewCount++;
                isReview = true;
            }else if(!isLocalRep && objWo?.objLuWorkOrderStatus?.intId==EE_LU_WO_STATUS.Certificate_Received) {
                intCertReceivedCount++;
                isCertReceived = true;
            }else if(objWo?.objLuWorkOrderStatus?.intId==EE_LU_WO_STATUS.Stop) {
                intStoppedCount++;
                isOnholdStopped = true;
            }
        }
     });
    }

let lstSubProjectStatus=[];

        let luStatusGC_1 = {
            intId : 4010,
            strLongDesc : 'Document Preparation',
            intStatusCount : intDocPrepCount,
            strShortDesc : '#BBB6A3'
        }
        lstSubProjectStatus.push(luStatusGC_1);

        let luStatusGC_2 = {
            intId : 4020,
            strLongDesc : 'Document Preparation & Sample Collection',
            intStatusCount : intDocPrepSampCollCount,
            strShortDesc : '#F4BE20'
        }
        lstSubProjectStatus.push(luStatusGC_2);

        let luStatusGC_3 = {
            intId : 4030,
            strLongDesc : 'Testing in Progress',
            intStatusCount : intTestInProgCount,
            strShortDesc : '#0FCC88'
        }
        lstSubProjectStatus.push(luStatusGC_3);

        let luStatusGC_4 = {
            intId : 4040,
            strLongDesc : 'Submission Complete',
            intStatusCount : intSubCompleteCount,
            strShortDesc : '#0fcbcc'
        }
        lstSubProjectStatus.push(luStatusGC_4);

        let luStatusGC_5 = {
            intId : 4050,
            strLongDesc : 'Application Under Review By Authority',
            intStatusCount : intReviewCount,
            strShortDesc : '#3e5ae8'
        }
        lstSubProjectStatus.push(luStatusGC_5);

        let luStatusGC_6 = {
            intId : 4060,
            strLongDesc : 'Certificate Received',
            intStatusCount : intCertReceivedCount,
            strShortDesc : '#a04dc1'
        }
        lstSubProjectStatus.push(luStatusGC_6);

        let luStatusGC_7 = {
            intId : 4003,
            strLongDesc : 'Completed',
            intStatusCount : intCompleteCount,
            strShortDesc : '#d4056c'
        }
        lstSubProjectStatus.push(luStatusGC_7);

        let luStatusGC_8 = {
            intId : 4005,
            strLongDesc : 'On Hold',
            intStatusCount : intOnholdCount+intStoppedCount,
            strShortDesc : '#D50237'
        }
        lstSubProjectStatus.push(luStatusGC_8);

        let luStatusGC_9 = {
            intId : 4006,
            strLongDesc : 'Cancelled',
            intStatusCount : intCancelCount,
            strShortDesc : '#FF6920'
        }
        lstSubProjectStatus.push(luStatusGC_9);

  return lstSubProjectStatus;
}

export const generateProjectGantChart = (objEEMaster) => {
  let objEEMasterForChart=objEEMaster;
let intCnt=0;
let dtStartDate=null;
let dtEndDate=null;
let dtStartDate2=null;
let dtEndDate2=null;
dtStartDate=new Date();
objEEMaster?.lstWorkOrder?.forEach((objWo) => {

if(objWo?.objLuWorkOrderStatus?.intId===4003){
  dtEndDate2=formatDateStringToDate(objWo?.dtCompletionDate);
  dtStartDate2=formatDateStringToDate(objWo?.dtStartDate);
}if(objWo?.objLuWorkOrderStatus?.intId===4004){
  dtEndDate2=formatDateStringToDate(objWo?.dtLastUpdateDate);
  dtStartDate2=formatDateStringToDate(objWo?.dtStartDate);
}if(objWo?.objLuWorkOrderStatus?.intId===4005){
  dtEndDate2=formatDateStringToDate(objWo?.dtExpComplDate);
  dtStartDate2=formatDateStringToDate(objWo?.dtStartDate);
}if(objWo?.objLuWorkOrderStatus?.intId===4006){
  dtEndDate2=formatDateStringToDate(objWo?.dtExpComplDate);
  dtStartDate2=formatDateStringToDate(objWo?.dtStartDate);
}if(objWo?.objLuWorkOrderStatus?.intId===4010){
  dtEndDate2=formatDateStringToDate(objWo?.dtExpComplDate);
  dtStartDate2=formatDateStringToDate(objWo?.dtPlannedStartDate);
}if(objWo?.objLuWorkOrderStatus?.intId===4020){
  dtEndDate2=formatDateStringToDate(objWo?.dtExpComplDate);
  dtStartDate2=formatDateStringToDate(objWo?.dtPlannedStartDate);
}if(objWo?.objLuWorkOrderStatus?.intId===4030){
  dtEndDate2=formatDateStringToDate(objWo?.dtEstimatedComplDate);
  dtStartDate2=formatDateStringToDate(objWo?.dtPlannedStartDate);
}if(objWo?.objLuWorkOrderStatus?.intId===4040){
  dtEndDate2=formatDateStringToDate(objWo?.dtEstimatedComplDate);
  dtStartDate2=formatDateStringToDate(objWo?.dtStartDate);
}if(objWo?.objLuWorkOrderStatus?.intId===4050){
  dtEndDate2=formatDateStringToDate(objWo?.dtEstimatedComplDate);
  dtStartDate2=formatDateStringToDate(objWo?.dtStartDate);
}if(objWo?.objLuWorkOrderStatus?.intId===4060){
  dtEndDate2=formatDateStringToDate(objWo?.dtEstimatedComplDate);
  dtStartDate2=formatDateStringToDate(objWo?.dtStartDate);
}

if(objEEMaster?.objProjectStatus?.intId==30004) {
  dtEndDate=formatDateStringToDate(objEEMaster?.dtProjActCompetionDate);
}else {
  
  if (objWo?.objLuWorkOrderStatus?.intId===4060 || objWo?.objLuWorkOrderStatus?.intId===4050 || objWo?.objLuWorkOrderStatus?.intId===4003) {
    if(dtEndDate==null) {
      dtEndDate=dtEndDate2;
    }else if (dtEndDate != null && dtEndDate2>dtEndDate) {
      dtEndDate = dtEndDate2;
    }
  } 
  
}
 if(dtEndDate==null)dtEndDate=dtEndDate2;
 if(dtEndDate!=null && dtEndDate2!=null && dtEndDate2>dtEndDate){
  dtEndDate=dtEndDate2;
}
 
 if(dtStartDate2==null)dtStartDate2=dtStartDate;
 if(dtStartDate!=null && dtStartDate2!=null && dtStartDate2<dtStartDate){
   dtStartDate=dtStartDate2;
}


      if(objEEMaster?.objProjectStatus?.intId==30004) {
          dtStartDate=formatDateStringToDate(objEEMaster?.dtProjPlannedStartDate);
          dtEndDate=formatDateStringToDate(objEEMaster?.dtProjActCompetionDate);
      }

});


  //lstCategory1 preparation
  //
  dtStartDate = getFirstDayOfWeek(dtStartDate);
  let dtCounter = new Date(dtStartDate.getFullYear(), dtStartDate.getMonth(), 1);
  let intMonthCountForDynamicWidth = 0;
  let lstCategory1 = [];
  //dtEndDate=new Date(dtEndDate);
  //
  while (dtStartDate !== null && dtCounter < dtEndDate) {
      //
  const calendar = new Date(dtCounter);
  const year = calendar.getFullYear();
  let year2 = calendar.getFullYear();
  const month = calendar.getMonth() + 1;
  let month2 = calendar.getMonth() + 1;
  const startDate = dtStartDate.getMonth() === calendar.getMonth()
                          ? 
                              getFirstDayOfWeek(dtStartDate).getDate()
                          : 1;
  //
  let daysInMonth = new Date(year, month, 0).getDate();
  const calendar2 = new Date();

  if (dtCounter.getMonth() === dtEndDate.getMonth()) {
      const endDate = getFirstDayOfWeek(dtEndDate);
      endDate.setDate(endDate.getDate() + 6);
      //daysInMonth = getDateComponent(endDate).getDate();
      daysInMonth = endDate.getDate();
      calendar2.setTime(endDate);
      year2 = calendar2.getFullYear();
      month2 = calendar2.getMonth() + 1;
  }

  lstCategory1.push({
      bgColor: '#ffffff',
      align: 'left',
      start: `${startDate}/${month}/${year} 00:00:00`,
      end: `${daysInMonth}/${month2}/${year2} 23:59:59`,
      label: new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      }).format(calendar),
  });
  

  dtCounter.setMonth(dtCounter.getMonth() + 1);

  // if (dtCounter < dtEndDate) {
  //     lstCategory1.push(',');
  // }

  intMonthCountForDynamicWidth++;
  }
  //

  //--------------lstCategory2 preparation
  let lstCategory2=[];
  dtCounter = new Date(dtStartDate);
  let dtDtDateTime = null;
  dtDtDateTime = new Date(dtStartDate);

  // Create a calendar object and set year and month
  let calendar = new Date(dtDtDateTime);
let weeks = Math.floor(
(new Date(dtEndDate) - new Date(dtStartDate)) / (7 * 24 * 60 * 60 * 1000)
) + 1;
let delta = -calendar.getDay() + 1; // Add 2 if your week starts on Monday
calendar.setDate(calendar.getDate() + delta);




for (let i = 1; i <= weeks; i++) {

let year = calendar.getFullYear();
let month = calendar.getMonth() + 1;
let daysInMonth = new Date(year, month, 0).getDate();

lstCategory2.push({
bgColor: "#ffffff",
align: "middle",
fontsize: "8",
start: `${formatDate1(calendar)} 00:00:00`,
end: `${formatDate1(new Date(calendar.getFullYear(), calendar.getMonth(), calendar.getDate() + 6))} 23:59:59`,
label: `${formatDate1(calendar)}-${formatDate1(
  new Date(calendar.getFullYear(), calendar.getMonth(), calendar.getDate() + 6)
)}(W${i})`,
});

calendar.setDate(calendar.getDate() + 7);
}
  

  
  //lstProcess preparation
  let lstProcess=[];
  intCnt = 0;

  if(objEEMaster?.lstWorkOrder != undefined){
      for (const objWo of objEEMaster?.lstWorkOrder) {
      lstProcess.push({
          tooltext: getWOProcessLabel(objWo,objEEMaster),
          height: '20',
          label: objWo?.objTblService?.strServiceName,
      });

  // if (++intCnt < objEEMaster.lstWorkOrder.length) {
  //     sbChart.push(',');
  // }
      }
  }

  //


  //lstDataColumn preparation
  let lstTextForDataColumn = [];
  intCnt = 0;
  if(objEEMaster?.lstWorkOrder != undefined){
      for (const objWo of objEEMaster?.lstWorkOrder) {
          lstTextForDataColumn.push({
          align: 'left',
          label: objWo?.objTblService?.objLuCountry?.strLongDesc.replace(/'/g, '`').trim(),
      });

  // if (++intCnt < objEEMaster.lstWorkOrder.length) {
  //     sbChart.push(',');
  // }
      }
  }


  let lstDataColumn = [
      {
          bgcolor: '#ffffff',
          headertext: 'Country /Territory',
          text: lstTextForDataColumn
      }
  ]
  //

  //lstTask preparation
  intCnt = 0;
  const lstTask = [];
  if(objEEMaster?.lstWorkOrder != undefined){
      for (const objWo of objEEMaster?.lstWorkOrder) {
      // Set boolRenewalArtifact property
      objWo.boolRenewalArtifact = objEEMaster?.boolRenewalArtifact;

      let startDate = new Date();
      let endDate = new Date();
      let progressbarColor = '#ffff00'; // Default color

      switch (objWo?.objLuWorkOrderStatus?.intId) {
          case 4002:
          progressbarColor = '#FBBE0D';
          startDate = new Date(formatDateStringToDate(objWo?.dtStartDate));
          endDate = new Date(formatDateStringToDate(objWo.dtEstimatedComplDate));
          break;
          case 4003:
          progressbarColor = '#d4056c';
          startDate = new Date(formatDateStringToDate(objWo.dtStartDate));
          endDate = new Date(formatDateStringToDate(objWo.dtCompletionDate));
          break;
          case 4004:
          progressbarColor = '#ffff00';
          if (objWo.dtStartDate && objWo.dtLastUpdateDate) {
              startDate = new Date(formatDateStringToDate(objWo.dtStartDate));
              endDate = new Date(formatDateStringToDate(objWo.dtLastUpdateDate));
          }
          break;
          case 4005:
          progressbarColor = '#d4056c';
          if (objWo.dtStartDate && objWo.dtLastUpdateDate) {
              startDate = new Date(formatDateStringToDate(objWo.dtStartDate));
              endDate = new Date(formatDateStringToDate(objWo.dtEstimatedComplDate));
          }
          break;
          case 4006:
          progressbarColor = '#FF6920';
          startDate = new Date(formatDateStringToDate(objWo.dtPlannedStartDate));

          if (
              (objWo.objLuPrevWorkOrderStatus.intId === 4010 ||
              objWo.objLuPrevWorkOrderStatus.intId === 4020) &&
              (objEEMasterForChart.dtProjDueDate &&
              objEEMasterForChart.dtProjDueDate)
          ) {
              endDate = new Date(formatDateStringToDate(objEEMaster.dtProjDueDate));
          } else if (
              objWo.objLuWorkOrderStatus.intId === 4004 ||
              objWo.objLuWorkOrderStatus.intId === 4005
          ) {
              endDate = new Date(formatDateStringToDate(objWo.dtEstimatedComplDate));
          }
          break;
          case 4010:
          progressbarColor = '#BBB6A3';
          startDate = new Date(formatDateStringToDate(objWo.dtPlannedStartDate));
          endDate = new Date(formatDateStringToDate(objWo.dtExpComplDate));
          break;
          case 4020:
          progressbarColor = '#F4BE20';
          startDate = new Date(formatDateStringToDate(objWo.dtPlannedStartDate));
          endDate = new Date(formatDateStringToDate(objWo.dtExpComplDate));
          break;
          case 4030:
          startDate = new Date(formatDateStringToDate(objWo.dtPlannedStartDate));
          endDate = new Date(formatDateStringToDate(objWo.dtEstimatedComplDate));
          progressbarColor = '#0FCC88';
          break;
          case 4040:
          progressbarColor = '#0fcbcc';
          startDate = new Date(formatDateStringToDate(objWo.dtStartDate));
          endDate = new Date(formatDateStringToDate(objWo.dtEstimatedComplDate));
          break;
          case 4050:
          progressbarColor = '#3e5ae8';
          startDate = new Date(formatDateStringToDate(objWo.dtStartDate));
          endDate = new Date(formatDateStringToDate(objWo.dtEstimatedComplDate));
          break;
          case 4060:
          progressbarColor = '#a04dc1';
          startDate = new Date(formatDateStringToDate(objWo.dtStartDate));
          endDate = new Date(formatDateStringToDate(objWo.dtEstimatedComplDate));
          break;
      }

      let strLabel = getWOProcessLabel(objWo,objEEMasterForChart);

      lstTask.push({
          start: `${startDate.getDate()}/${startDate.getMonth() + 1}/${startDate.getFullYear()} 00:00:00`,
          end: `${endDate.getDate()}/${endDate.getMonth() + 1}/${endDate.getFullYear()} 23:59:59`,
          color: progressbarColor,
          height: '70%',
          label: strLabel,
          toppadding: '12%',
      });

  //   if (++intCnt < objEEMaster.lstWorkOrder.length) {
  //     sbChart.push(',');
  //   }
      }
  }
  //

  //lstTrendLines preparation
  let lstTrendLines = [];
  lstTrendLines.push(
              {
                  line: [
                      {
                          start: new Date().toLocaleDateString('en-GB') , // Format date as 'dd/MM/yyyy'
                          displayValue: 'Today',
                          color: '#D50237',
                          thickness: '2',
                          dashed: '1'
                      }       
                          ]
              }
  );
  
  //


  const dataSource = {
      chart: {
        dateformat: "dd/mm/yyyy",
        //caption: "Event Planning Process in Approvals",
         canvasborderalpha: "40",
      //   ganttlinealpha: "50",
        outputdateformat : 'ddds mns yy',
        ganttwidthpercent : '75',
        ganttPaneDuration : '25',
        ganttPaneDurationUnit : 'd',
        plottooltext : '$label{br}',
        legendBorderAlpha : '0',
        flatScrollBars : '0',
        gridbordercolor : '#ffffff',
        gridborderalpha : '20',
        slackFillColor : '#ffffff',
        taskBarFillMix : 'light+0',
        canvasPadding: "0"
        //theme: "fusion",
      },

      categories : [
          {
              category : lstCategory1
          },
          {
              category : lstCategory2
          },
      ],

      processes :  {
  headertext: '',
  headerBgColor: '#ffffff', 
  width:'35%', 
  fontsize: '10', 
  align: 'left',
  isbold: '0', 
  headeralign: 'left', 
  process: lstProcess
      },

      datatable : {
          showprocessname: '1', 
          namealign: 'left', 
          fontcolor: '#000000', 
          fontsize: '12', 
          valign: 'right', 
          align: 'center', 
          headervalign: 'bottom', 
          headeralign: 'center', 
          headerbgcolor: '#ffffff', 
          headerfontcolor: '#000000', 
          headerfontsize: '10',
          datacolumn: lstDataColumn
      },

      tasks : {
          task : lstTask
      },

      trendlines : lstTrendLines
  }
//console.log(JSON.stringify(dataSource));
return dataSource;
}

function getFirstDayOfWeek(date) {
  const day = date.getDay();
  const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Adjust for Sunday
  const monday = new Date(date);
  monday.setDate(diff);
  monday.setHours(0, 0, 0, 0);
  return monday;
}

export const formatDateStringToDate = (dateString) => {
  // Input date string in the format DD/MM/YYYY HH:MM:SS
if(dateString !== undefined && dateString !== null){
  const parts = dateString?.split(/[\s/:]/); // Split the string by space, /, and :

// Extract the date components
const day = parseInt(parts[0], 10);
const month = parseInt(parts[1], 10) - 1; // Subtract 1 from the month since JavaScript months are zero-based (0-11)
const year = parseInt(parts[2], 10);
const hours = parseInt(parts[3], 10);
const minutes = parseInt(parts[4], 10);
const seconds = parseInt(parts[5], 10);

// Create a new Date object with the extracted components
const date = new Date(year, month, day, hours, minutes, seconds);
return date;
}    

return null;
}

function formatDate1(date) {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${day}/${month}/${year}`;
}

function getWOProcessLabel(objWo,objEEMasterForChart) {
  let txt = "";

  try {
    txt =
      "Country/Territory : " +
      objWo.objTblService.objLuCountry.strLongDesc.replace(/'/g, "`") +
      "<br> Service Type :" +
      objWo.objTblService.objLuServiceCode.strLongDesc.replace(/'/g, "`") +
      "<br> Certificate Name :" +
      objWo.objTblService.strServiceName.replace(/'/g, "`") +
      "<br> Sub Project Status :" +
      objWo.objLuWorkOrderStatus.strLongDesc.replace(/'/g, "`") +
      "<br> Product Model :" +
      (objWo.boolSingleCertificate ? "All" : objWo.objEEMaster.strSeriesModel).replace(
        /'/g,
        "`"
      ) +
      "<br> Brand/OEM :" +
      (objWo.boolSingleCertificate
        ? "All"
        : objWo.objEEMaster.objBrandName.strLongDesc).replace(/'/g, "`") +
      "<br> Recommended Start Date :" +
      (objEEMasterForChart.dtProjPlannedStartDate
        ? new Intl.DateTimeFormat("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
          }).format(new Date(formatDateStringToDate(objWo.dtPlannedStartDate)))
        : "");

    if (objWo.boolRenewalArtifact) {
      txt =
        txt +
        "<br> Deadline :" +
        (objWo.dtPrevCertDate
          ? new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            }).format(new Date(formatDateStringToDate(objWo.dtPrevCertDate)))
          : "");
    } else {
      if (
        objWo.objLuWorkOrderStatus.intId === 4010 ||
        objWo.objLuWorkOrderStatus.intId === 4020
      ) {
        txt =
          txt +
          "<br> Deadline :" +
          (objWo.dtExpComplDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtExpComplDate)))
            : "");
      }

      if (
        objWo.objLuWorkOrderStatus.intId === 4030 ||
        objWo.objLuWorkOrderStatus.intId === 4040 ||
        objWo.objLuWorkOrderStatus.intId === 4050 ||
        objWo.objLuWorkOrderStatus.intId === 4060
      ) {
        txt =
          txt +
          "<br>Actual Start Date :" +
          (objWo.dtStartDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtStartDate)))
            : "") +
          "<br> Deadline :" +
          (objWo.dtEstimatedComplDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtEstimatedComplDate)))
            : "");
      }

      if (
        (objWo.objLuWorkOrderStatus.intId === 4004 ||
          objWo.objLuWorkOrderStatus.intId === 4005) &&
        (objWo.objLuPrevWorkOrderStatus.intId === 4010 ||
          objWo.objLuPrevWorkOrderStatus.intId === 4020) &&
        (objEEMasterForChart.dtProjDueDate &&
          objEEMasterForChart.dtProjDueDate)
      ) {
        txt =
          txt +
          "<br> Deadline :" +
          (objWo.dtExpComplDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtExpComplDate)))
            : "");
      } else if (
        objWo.objLuWorkOrderStatus.intId === 4004 ||
        objWo.objLuWorkOrderStatus.intId === 4005
      ) {
        txt =
          txt +
          "<br>Actual Start Date :" +
          (objWo.dtStartDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtStartDate)))
            : "") +
          "<br> Deadline :" +
          (objWo.dtEstimatedComplDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtEstimatedComplDate)))
            : "");
      }

      if (objWo.objLuWorkOrderStatus.intId === 4003) {
        txt =
          txt +
          "<br>Actual Start Date :" +
          (objWo.dtStartDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtStartDate)))
            : "") +
          "<br> Deadline :" +
          (objWo.dtEstimatedComplDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo?.dtEstimatedComplDate)))
            : "") +
          "<br>Actual Completion Date :" +
          (objWo.dtCompletionDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtCompletionDate)))
            : "");
      }

      if (
        objWo.objLuWorkOrderStatus.intId === 4006 &&
        (objWo.objLuPrevWorkOrderStatus.intId === 4010 ||
          objWo.objLuPrevWorkOrderStatus.intId === 4020)
      ) {
        txt =
          txt +
          "<br>Actual Start Date :" +
          (objEEMasterForChart.dtProjPlannedStartDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objEEMasterForChart.dtProjPlannedStartDate)))
            : "") +
          "<br> Deadline :" +
          (objEEMasterForChart.dtProjDueDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objEEMasterForChart.dtProjDueDate)))
            : "") +
          "<br> Cancelled Date :" +
          (objWo.dtLastUpdateDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtLastUpdateDate)))
            : "");
      } else if (objWo.objLuWorkOrderStatus.intId === 4006) {
        txt =
          txt +
          "<br>Actual Start Date :" +
          (objWo.dtStartDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtStartDate)))
            : "") +
          "<br> Deadline :" +
          (objWo.dtEstimatedComplDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtEstimatedComplDate)))
            : "") +
          "<br> Cancelled Date :" +
          (objWo.dtLastUpdateDate
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              }).format(new Date(formatDateStringToDate(objWo.dtLastUpdateDate)))
            : "");
      }

      txt = txt + "";
    }
  } catch (e) {
    console.error(e);
  }

  return txt;
}


function progressBarData(key, status, subProjectCount, progress, color) {
  return {
    key: key,
    status: status,
    subProjectCount: subProjectCount,
    progress: progress,
    color: color,
  };
}

export function getJsonDataForSubProjects(data) {
  let jsonResult = [];
  data.map((objWo) => {
   
    let total = parseInt(
      (objWo?.lstLuStatusCounts[0]?.intStatusCount || 0) +
      (objWo?.lstLuStatusCounts[1]?.intStatusCount || 0) +
      (objWo?.lstLuStatusCounts[2]?.intStatusCount || 0) +
      (objWo?.lstLuStatusCounts[3]?.intStatusCount || 0) +
      (objWo?.lstLuStatusCounts[4]?.intStatusCount || 0) +
      (objWo?.lstLuStatusCounts[5]?.intStatusCount || 0)
    );
    if (!isNaN(total)) {
      jsonResult.push(getWaveChartJsonData(objWo?.strLongDesc, 'Total', total,objWo?.intId));
    }

    let started = parseInt(
      (objWo?.lstLuStatusCounts[2]?.intStatusCount || 0) +
      (objWo?.lstLuStatusCounts[3]?.intStatusCount || 0) +
      (objWo?.lstLuStatusCounts[4]?.intStatusCount || 0) +
      (objWo?.lstLuStatusCounts[5]?.intStatusCount || 0)
    );
    

    if (!isNaN(started)) {
      jsonResult.push(getWaveChartJsonData(objWo?.strLongDesc, 'Started', started,objWo?.intId));
    }

    let notStarted = parseInt(
      (objWo?.lstLuStatusCounts[0]?.intStatusCount || 0) +
      (objWo?.lstLuStatusCounts[1]?.intStatusCount || 0)
    );
    

    if (!isNaN(notStarted)) {
      jsonResult.push(getWaveChartJsonData(objWo?.strLongDesc, 'Not Started', notStarted,objWo?.intId));
    }

  });
  return jsonResult;
}

function getWaveChartJsonData(date, type, value,intId) {
  return {
    date: date,
    type: type,
    value: value,
    intId: intId
  };
}

export function getTotalCount(data, flag, key) {
  if (flag == 1) {
    let intTotalStatedCount = 0;
    let intTotalNotStartedCount = 0;
    let intTotalSubProjectCount = 0;
    data.map((onjStatusCount) => {
      onjStatusCount.lstLuStatusCounts.map((objStatus) => {
        intTotalSubProjectCount += objStatus.intStatusCount != null ? objStatus.intStatusCount : 0;
        if (
          onjStatusCount.intId != null &&
          onjStatusCount.intId != 100 &&
          onjStatusCount.intId != 170 &&
          onjStatusCount.intId != 180
        ) {
          if (objStatus.intId != null && (objStatus.intId == 4010 || objStatus.intId == 4020)) {
            intTotalNotStartedCount +=
              objStatus.intStatusCount != null ? objStatus.intStatusCount : 0;
          } else if (
            objStatus.intId != null &&
            (objStatus.intId == 4030 ||
              objStatus.intId == 4040 ||
              objStatus.intId == 4050 ||
              objStatus.intId == 4060)
          ) {
            intTotalStatedCount += objStatus.intStatusCount != null ? objStatus.intStatusCount : 0;
          }
        }
      });
    });
    switch (key) {
      case 0:
        return intTotalSubProjectCount;
      case 1:
        return intTotalStatedCount;
      case 2:
        return intTotalNotStartedCount;
      default:
        return 0;
    }
  }

  if (flag == 2) {
    let intTotalRenewalCertCount = 0;
    let intTotalRenewalUndecidedCount = 0;
    let intTotalRenewalDecidedCount = 0;
    data.forEach((onjStatusCount) => {
      onjStatusCount?.lstLuStatusCounts.forEach((objStatus) => {
        intTotalRenewalCertCount += objStatus.intStatusCount != null ? objStatus.intStatusCount : 0;
        if (
          onjStatusCount.intId != null &&
          onjStatusCount.intId != 120 &&
          onjStatusCount.intId != 110 &&
          onjStatusCount.intId != 180
        ) {
          if (objStatus.intId != null && objStatus.intId == 6010) {
            intTotalRenewalUndecidedCount +=
              objStatus.intStatusCount != null ? objStatus.intStatusCount : 0;
          } else {
            intTotalRenewalDecidedCount +=
              objStatus.intStatusCount != null ? objStatus.intStatusCount : 0;
          }
        }
      });
    });
    switch (key) {
      case 0:
        return intTotalRenewalCertCount;
      case 1:
        return intTotalRenewalUndecidedCount;
      case 2:
        return intTotalRenewalDecidedCount;
      default:
        return 0;
    }
  }

  if (flag == 3) {
    let intTotalExpiryCertCount = 0;
    let intTotalExpiryUndecidedCount = 0;
    let intTotalExpiryDecidedCount = 0;
    data.forEach((onjStatusCount) => {
      onjStatusCount?.lstLuStatusCounts.forEach((objStatus) => {
        intTotalExpiryCertCount += objStatus.intStatusCount != null ? objStatus.intStatusCount : 0;
        if (
          onjStatusCount.intId != null &&
          onjStatusCount.intId != 220 &&
          onjStatusCount.intId != 210 &&
          onjStatusCount.intId != 290
        ) {
          if (objStatus.intId != null && objStatus.intId == 6010) {
            intTotalExpiryUndecidedCount +=
              objStatus.intStatusCount != null ? objStatus.intStatusCount : 0;
          } else {
            intTotalExpiryDecidedCount +=
              objStatus.intStatusCount != null ? objStatus.intStatusCount : 0;
          }
        }
      });
    });
    switch (key) {
      case 0:
        return intTotalExpiryCertCount;
      case 1:
        return intTotalExpiryUndecidedCount;
      case 2:
        return intTotalExpiryDecidedCount;
      default:
        return 0;
    }
  }
  return 0;
}

export function getCertificateRenewalCountsChartData(data) {
  let total = 0;
  let jsonData = [];
  let intStatusCount = 0;

  data.forEach((renewalCounts) => {
    renewalCounts?.lstLuStatusCounts.forEach((objStatus) => {
      intStatusCount += objStatus?.intStatusCount;
    });
  });
  data.forEach((renewalCounts) => {
    let allTotal = 0;
    allTotal +=
      (renewalCounts?.lstLuStatusCounts[0]?.intStatusCount || 0) +
      (renewalCounts?.lstLuStatusCounts[1]?.intStatusCount || 0) +
      (renewalCounts?.lstLuStatusCounts[2]?.intStatusCount || 0) +
      (renewalCounts?.lstLuStatusCounts[3]?.intStatusCount || 0) +
      (renewalCounts?.lstLuStatusCounts[4]?.intStatusCount || 0) +
      (renewalCounts?.lstLuStatusCounts[5]?.intStatusCount || 0) +
      (renewalCounts?.lstLuStatusCounts[6]?.intStatusCount || 0) +
      (renewalCounts?.lstLuStatusCounts[7]?.intStatusCount || 0);

    jsonData.push(getWaveChartJsonData(renewalCounts?.strLongDesc, 'Total', allTotal,renewalCounts?.intId));
    let undecided = 0;
    if (
      renewalCounts?.intId !== 120 &&
      renewalCounts?.intId !== 110 &&
      renewalCounts?.intId !== 180
    ) {
      undecided =
        intStatusCount !== null && intStatusCount !== 0
          ? renewalCounts.lstLuStatusCounts[0].intStatusCount
          : 0;
    }
    jsonData.push(getWaveChartJsonData(renewalCounts?.strLongDesc, 'Undecided', undecided,renewalCounts?.intId));
    let decided = 0;
    if (
      renewalCounts?.intId !== 120 &&
      renewalCounts?.intId !== 110 &&
      renewalCounts?.intId !== 180
    ) {
      decided =
        intStatusCount !== null && intStatusCount !== 0
          ? allTotal - (renewalCounts?.lstLuStatusCounts[0]?.intStatusCount || 0)
          : 0;
    }
    jsonData.push(getWaveChartJsonData(renewalCounts?.strLongDesc, 'Decided', decided,renewalCounts?.intId));
  });
  return jsonData;
}

export function getCertificateExpireCountsChartData(data) {
  let total = 0;
  let jsonData = [];
  let intStatusCount = 0;

  data.forEach((expireCounts) => {
    expireCounts?.lstLuStatusCounts.forEach((objStatus) => {
      intStatusCount += objStatus?.intStatusCount;
    });
  });
  data.forEach((expireCounts) => {
    let allTotal = 0;
    allTotal +=
      (expireCounts?.lstLuStatusCounts[0]?.intStatusCount || 0) +
      (expireCounts?.lstLuStatusCounts[1]?.intStatusCount || 0) +
      (expireCounts?.lstLuStatusCounts[2]?.intStatusCount || 0) +
      (expireCounts?.lstLuStatusCounts[3]?.intStatusCount || 0) +
      (expireCounts?.lstLuStatusCounts[4]?.intStatusCount || 0) +
      (expireCounts?.lstLuStatusCounts[5]?.intStatusCount || 0) +
      (expireCounts?.lstLuStatusCounts[6]?.intStatusCount || 0);

    jsonData.push(getWaveChartJsonData(expireCounts?.strLongDesc, 'Total', allTotal,expireCounts?.intId));
    let undecided = 0;
    if (expireCounts?.intId !== 220 && expireCounts?.intId !== 210 && expireCounts?.intId !== 290) {
      undecided =
        intStatusCount !== null && intStatusCount !== 0
          ? expireCounts.lstLuStatusCounts[0].intStatusCount
          : 0;
    }
    jsonData.push(getWaveChartJsonData(expireCounts?.strLongDesc, 'Undecided', undecided,expireCounts?.intId));
    let decided = 0;
    if (expireCounts?.intId !== 120 && expireCounts?.intId !== 110 && expireCounts?.intId !== 180) {
      decided =
        intStatusCount !== null && intStatusCount !== 0
          ? allTotal -
            ((expireCounts?.lstLuStatusCounts[0]?.intStatusCount || 0) +
              (expireCounts?.lstLuStatusCounts[6]?.intStatusCount || 0))
          : 0;
    }
    jsonData.push(getWaveChartJsonData(expireCounts?.strLongDesc, 'Decided', decided,expireCounts?.intId));
  });
  return jsonData;
}


export function formatDateDifference(dateString) {
  const dateParts = dateString.split(/[\s/]/); // Split the date string by whitespace and '/'
  const givenDate = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]} ${dateParts[3]}`); // Construct a Date object from the date string

  const currentDate = new Date();
  const diffInMs = currentDate - givenDate; // Get the difference in milliseconds
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24)); // Convert milliseconds to days

  const years = Math.floor(diffInDays / 365);
  const months = Math.floor((diffInDays % 365) / 30);
  const days = diffInDays % 30;

  let result = '';
  if (years > 0) {
      result += `${years} year${years > 1 ? 's' : ''} `;
  }
  if (months > 0) {
      result += `${months} month${months > 1 ? 's' : ''} `;
  }
  if (days > 0) {
      result += `${days} day${days > 1 ? 's' : ''} `;
  }

  return result.trim();
}
